export const forumPageData = {
  vision: '金融向善，持续未来。',
  enVision: 'Finance for Good, Sustainability for Future.',
  mission: '成为绿色金融领域具有公信力与影响力的思想引领平台。',
  enMission: 'To build a thought leadership platform to foster international cooperation in green finance.'
};

export const activityPageData = {
  tabList: [
    {
      id: 1,
      tit: '专业研讨',
      enTit: 'Seminar'
    },
    {
      id: 3,
      tit: '年度峰会',
      enTit: 'Summit'
    }
  ],
};

export const expertPageData = [
  {
    avatar: '11.png',
    name: '蔡清福',
    enName: 'Alvin CHUA',
    desc: ['中银国际董事总经理'],
    enDesc: ['Managing Director, Bank of China International']
  }, {
    avatar: '2.png',
    name: '洪永淼',
    enName: 'Yongmiao HONG',
    desc: ['中国科学院大学经济与管理学院院长'],
    enDesc: ['Dean, School of Economics and Management, University of Chinese Academy of Sciences']
  }, {
    avatar: '10.png',
    name: '赖晓明',
    enName: 'Xiaoming LAI',
    desc: ['上海环境能源交易所董事长'],
    enDesc: ['Chairman, Shanghai Environment and Energy Exchange']
  }, {
    avatar: '1.png',
    name: '刘明康',
    enName: 'Mingkang LIU',
    desc: ['原中国银监会主席', 'GF60学术委员会教授'],
    enDesc: ['Former President, China Banking Regulatory Commission', 'Professor, GF60 Academic committee']
  }, {
    avatar: '8.png',
    name: '廖双辉',
    enName: 'Shuanghui LIAO',
    desc: ['投投科技董事长', 'GF60秘书长'],
    enDesc: ['Chairman, Total Fintech', 'Secretary-general, GF60']
  }, {
    avatar: '5.png',
    name: 'Michael Spence',
    enName: 'Michael SPENCE',
    desc: ['斯坦福大学教授', '2001年诺贝尔经济学奖得主'],
    enDesc: ['Professor, Stanford Graduate School of Bussiness', '2001 Nobel Memorial Prize in Economics']
  }, {
    avatar: '9.png',
    name: '彭  澎',
    enName: 'Peng PENG',
    desc: ['中国新能源电力投融资联盟秘书长'],
    enDesc: ['Secretary-General, China New Energy Investment and Financing Alliance']
  }, {
    avatar: '6.png',
    name: 'Saeb Eigner',
    enName: 'Saeb EIGNER',
    desc: ['迪拜金融服务局原主席'],
    enDesc: ['Former Chairman, Dubai Financial Services']
  }, {
    avatar: '7.png',
    name: '史美伦',
    enName: 'Laura CHA',
    desc: ['香港交易所董事会主席'],
    enDesc: ['Chairman, Hong Kong Exchange and Clearing']
  }, {
    avatar: '12.png',
    name: '王兰凤',
    enName: 'Lanfeng WANG',
    desc: ['苏州银行董事长'],
    enDesc: ['Chairman, Bank of Suzhou']
  }, {
    avatar: '3.png',
    name: '张俊杰',
    enName: 'Junjie ZHANG',
    desc: ['清华大学苏世民学院可持续发展访问讲席教授', 'GF60首席经济学家'],
    enDesc: ['Volkswagen Visiting Chair in Sustainability Schwarzman Scholars Program，Tsinghua University', 'Chief Ecinomist, GF60']
  }, {
    avatar: '4.png',
    name: '朱晓明',
    enName: 'Xiaoming ZHU',
    desc: ['中欧国际工商学院原院长'],
    enDesc: ['Dean Emeritus, China Europe International Business School']
  }
];

/* GF60介绍 - 研究方向 */
export const researchAreaList = [
  {
    imgUrl: 'carbon.jpg',
    tit: '碳市场',
    enTit: 'Carbon Market',
    desc: '持续跟踪调研全国及地方试点碳市场，并通过对强制市场、自愿市场等不同层次碳市场的总体架构、发展路线及现实阻碍进行深入分析，为碳市场发展及碳金融产品创新提供切实建议与行动规划。',
    enDesc: 'GF60 continues to track and research national and local pilot carbon markets, conducting in-depth analyses of the overall framework, development paths, and practical obstacles of carbon markets at different levels, including mandatory and voluntary markets. This aims to provide practical recommendations and action plans for the development of carbon markets and the innovation of carbon financial products.'
  },
  {
    imgUrl: 'climate.jpg',
    tit: '气候金融',
    enTit: 'Climate Finance',
    desc: '密切关注气候变化对投融资活动带来的实际影响，依托转型金融、低碳金融课题研究，分析碳密集产业特点及减排路径，探索绿色金融支持低碳行业的机制建设与政策完善，助力企业绿色低碳发展。',
    enDesc: 'GF60 closely monitors the material impacts of climate change on investment and financing activities. Drawing on research topics related to transition fiannce and low-carbon finance, it analyzes the characteristics of carbon-intensive industries and emission reduction pathways. GF60 promotes green finance mechanisms for an enabling policy environment to support low-carbon industries and the transition to a green economy. '
  },
  {
    imgUrl: 'esg.jpg',
    tit: 'ESG',
    enTit: 'Environment, Social and Governance',
    desc: '深入分析国内外ESG标准体系与发展情况，围绕评级、投资、实践三大领域开展ESG研究工作，为金融机构与产业公司提供ESG方法论指导与分析工具支持，并通过创新开发各类绿色金融产品引导资金流向。',
    enDesc: 'GF60 conducts in-depth analyses of domestic and international ESG standard systems and developments. Focusing on the areas of ESG credit ratings, investment and good practices, GF60  supports financial institutions and corporates with methodological guidance and analytical tools to drive continous ESG improvements. GF60 also explores innovative financing mechanisms and investment products to mobilize financial flows into the climate-friendly sectors.'
  }
];

export const researchMenuList = [
  { tit: '政策分析', enTit: 'Policy', imgUrl: 'zcfx.jpg'},
  { tit: '标准建设', enTit: 'Standard', imgUrl: 'bzjs.png'},
  { tit: '产业研究', enTit: 'Industry', imgUrl: 'cyyj.png'},
  { tit: '评价体系', enTit: 'Evaluation', imgUrl: 'pjtx.png'},
  { tit: '指数开发', enTit: 'Index', imgUrl: 'zskf.png'}
];

export const scopeWorkList = [
  {
    order: '01',
    imgUrl: 'xsjl.png',
    tit: '学术交流',
    enTit: 'Academic Exchange',
    desc: '通过各类调研与研究课题的交流论证，推进研究工作深入完善。',
    enDesc: 'Through organizing academic exchanges and field studies on various research topics, GF60 deepens our efforts in research.'
  },
  {
    order: '02',
    imgUrl: 'ztyt.png',
    tit: '专题研讨',
    enTit: 'Seminar',
    desc: '围绕重要议题与前沿趋势开展探讨，助力市场研究与产业落地。',
    enDesc: 'Through featured discussions and seminars on crucial issues and cutting-edge trends, GF60 promotes market insights and industry partnerships.'
  },
  {
    order: '03',
    imgUrl: 'nljs.png',
    tit: '能力建设',
    enTit: 'Capacity Building',
    desc: '通过创新型培训模式，助推金融机构和企业绿色发展软实力。',
    enDesc: 'Through innovative training modules, GF60 boosts green capacity building for financial institutions and businesses.'
  },
  {
    order: '04',
    imgUrl: 'zxfw.png',
    tit: '咨询服务',
    enTit: 'Consulting Service',
    desc: '为机构、企业可持续发展提供专业项目咨询与一站式解决方案。',
    enDesc: 'Through professional consulting and advisory services, GF60 offers comprehensive and one-stop sustainability solutions to institutions and businesses.'
  },
  {
    order: '05',
    imgUrl: 'sngd.png',
    tit: '司南观点',
    enTit: 'Jinsinan Insights',
    desc: '以多样化传播手段输出GF60专家洞见，引领经济社会可持续发展。',
    enDesc: 'Through influential communication and outreach channels, GF60 disseminates insights of GF60 experts on  sustainable development.'
  },
  {
    order: '06',
    imgUrl: 'hydy.png',
    tit: '行业调研',
    enTit: 'Industry Survey',
    desc: '制定个性化考察项目，交流学习标杆企业先进经验及绿色理念。',
    enDesc: 'Through tailored programs, GF60 promotes industrial exchange, peer learning and experience sharing of green development and practices from leading enterprises.'
  }
];

export const testLCBList = [
  {
    yearImg: 'test-year.jpg',
    year: '2023',
    eventList: [
      {
        time: '2021/05',
        desc: '5月，GF60筹委会在沪召开第一次筹备会议，会上确定GF60的平台定位、工作方向与使命愿景。',
        enDesc: 'The Preparatory Committee confirm the aims, mission, and vision of GF60.'
      },
      {
        time: '2021/05',
        desc: '5月，GF60筹委会在沪召开第一次筹备会议，会上确定GF60的平台定位、工作方向与使命愿景。',
        enDesc: 'The Preparatory Committee confirm the aims, mission, and vision of GF60.'
      },
      {
        time: '2021/05',
        desc: '5月，GF60筹委会在沪召开第一次筹备会议，会上确定GF60的平台定位、工作方向与使命愿景。',
        enDesc: 'The Preparatory Committee confirm the aims, mission, and vision of GF60.'
      }
    ]
  },
  {
    yearImg: 'test-year.jpg',
    year: '2022',
    eventList: [
      {
        time: '2021/05',
        desc: '5月，GF60筹委会在沪召开第一次筹备会议，会上确定GF60的平台定位、工作方向与使命愿景。',
        enDesc: 'The Preparatory Committee confirm the aims, mission, and vision of GF60.'
      },
      {
        time: '2021/05',
        desc: '5月，GF60筹委会在沪召开第一次筹备会议，会上确定GF60的平台定位、工作方向与使命愿景。',
        enDesc: 'The Preparatory Committee confirm the aims, mission, and vision of GF60.'
      },
      {
        time: '2021/05',
        desc: '5月，GF60筹委会在沪召开第一次筹备会议，会上确定GF60的平台定位、工作方向与使命愿景。',
        enDesc: 'The Preparatory Committee confirm the aims, mission, and vision of GF60.'
      }
    ]
  },
  {
    yearImg: 'test-year.jpg',
    year: '2021',
    eventList: [
      {
        time: '2021/05',
        desc: '5月，GF60筹委会在沪召开第一次筹备会议，会上确定GF60的平台定位、工作方向与使命愿景。',
        enDesc: 'The Preparatory Committee confirm the aims, mission, and vision of GF60.'
      }
    ]
  },
  {
    yearImg: 'test-year.jpg',
    year: '2020',
    eventList: [
      {
        time: '2021/05',
        desc: '5月，GF60筹委会在沪召开第一次筹备会议，会上确定GF60的平台定位、工作方向与使命愿景。5月，GF60筹委会在沪召开第一次筹备会议，会上确定GF60的平台定位、工作方向与使命愿景。5月，GF60筹委会在沪召开第一次筹备会议，会上确定GF60的平台定位、工作方向与使命愿景。',
        enDesc: 'The Preparatory Committee confirm the aims, mission, and vision of GF60.The Preparatory Committee confirm the aims, mission, and vision of GF60.The Preparatory Committee confirm the aims, mission, and vision of GF60.'
      },
      {
        time: '2021/05',
        desc: '5月，GF60筹委会在沪召开第一次筹备会议，会上确定GF60的平台定位、工作方向与使命愿景。',
        enDesc: 'The Preparatory Committee confirm the aims, mission, and vision of GF60.'
      }
    ]
  }
]
